import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

const generateGuestSessionId = () => `session_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;

interface AuthState {
    accessToken: string | null;
    refreshToken: string | null;
    guestSessionId?: string;
    user_id: string;
    user_code: string;
    cust_name: string;
    tel_number: string;

    setAuth: (data: Partial<AuthState>) => void;
    clearAuth: () => void;
    logout: () => void;
}

const customStorage: PersistStorage<AuthState> = {
    getItem: name => {
        const item = localStorage.getItem(name);
        return item ? JSON.parse(item) : null;
    },
    setItem: (name, value) => {
        localStorage.setItem(name, JSON.stringify(value));
    },
    removeItem: name => {
        localStorage.removeItem(name);
    },
};

export const useExpressAuthStore = create(
    persist<AuthState>(
        (set, get) => {
            const existingGuestSessionId = typeof window !== "undefined" && localStorage.getItem("guest_session_id");

            const newGuestSessionId = existingGuestSessionId || generateGuestSessionId();

            if (!existingGuestSessionId && typeof window !== "undefined") {
                localStorage.setItem("guest_session_id", newGuestSessionId);
            }

            return {
                accessToken: null,
                refreshToken: null,
                guestSessionId: newGuestSessionId,
                user_id: "",
                user_code: "",
                cust_name: "",
                tel_number: "",

                setAuth: data => set(state => ({ ...state, ...data })),

                clearAuth: () => {
                    customStorage.removeItem("auth-storage");
                    set({
                        accessToken: null,
                        refreshToken: null,
                        guestSessionId: get().guestSessionId,
                        user_id: undefined,
                        user_code: undefined,
                        cust_name: undefined,
                        tel_number: undefined,
                    });
                },

                logout: () =>
                    set(state => ({
                        ...state,
                        accessToken: null,
                        refreshToken: null,
                    })),
            };
        },
        {
            name: "auth-storage",
            storage: customStorage,
        },
    ),
);
